<template>
  <v-dialog v-model="warningZone" persistent max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">Warning</span>
      </v-card-title>
      <v-card-text>
        <v-container>                    
          <v-row>
            <v-col cols="12">
              <span>Are you still with us?</span>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="resetTimer" color="primary darken-1">Close</v-btn>                
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AutoLogout',  
  data() {
    return {
      events: ['click', 'mousemove', 'mousedown', 'scroll', 'keypress', 'load'],
      warningTimeout: 14 * 60 * 1000,
      logoutTimeout:  60 * 1000,
      warningTimerID: null,
      logoutTimerID: null,
      warningZone: false,
    }
  },
  mounted() {     
    this.events.forEach((event) => {
      window.addEventListener(event, this.resetTimer);
    }, this);
    this.setTimer();           
  },
  destroyed() {        
    this.handleIcon()  
    this.events.forEach((event) => {
      window.removeEventListener(event, this.resetTimer);
    }, this);             
  },
  methods: {      
    setTimer() {             
      this.warningTimerID = setTimeout(this.warningMessage, this.warningTimeout);     
      this.handleIcon();
      this.warningZone = false;
    },
    resetTimer() {            
      clearTimeout(this.warningTimerID);
      clearTimeout(this.logoutTimerID);      
      this.setTimer();     
    },
    warningMessage() {          
      this.warningZone = true;
      clearTimeout(this.warningTimerID)
      this.logoutTimerID = setTimeout(this.logout, this.logoutTimeout )    
      this.handleIconDanger()
    },    
    async logout() {           
      try {              
        await axios.post('api/v1/auth/logout')
        
        this.$store.dispatch('deleteUser')
        this.$router.push('/login')
      } catch (error) {               

      }
    },  
    handleIcon() {              
      const favicon = document.getElementById("favicon");                                              
      favicon.href = "./favicon.ico"          
    },
    handleIconDanger() {
      const favicon = document.getElementById("favicon"); 
      favicon.href = "./faviconDanger.ico"
    }   
  }
}

</script>
